import {Inject, Injectable} from '@angular/core';
import {injectNoScript, injectScript} from 'app/core/helpers/dom';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';
import {EnvName, getEnvName} from '../../../environments/env-name';

declare const ym;
const ymScript = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym")`;
const ymNoScript = code => `<div><img src="https://mc.yandex.ru/watch/${code}" style="position:absolute; left:-9999px;" alt="" /></div>`;

@Injectable()
export class YandexMetricaService {
    readonly ymCode = 88804951;
    ym = function (code, event, actionName) {
        console.debug('[Yandex.Metrica]', ...arguments);
    };

    constructor(@Inject(I18NEXT_SERVICE) private i18Next: ITranslationService) {}

    inject() {
        injectScript(ymScript, document.head);
        injectNoScript(ymNoScript(this.ymCode), document.head);
    }

    init() {
        if (getEnvName() !== EnvName.Prod) {
            return;
        }
        this.inject();

        this.ym = typeof ym !== 'undefined' ? ym : this.ym;
        this.ym(this.ymCode, 'init', {
            id: this.ymCode,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
        });
    }

    sendEvent(actionName: string): void {
        this.ym(this.ymCode, 'reachGoal', actionName);
    }
}
